<div [formGroup]="descriptionSectionForm">
  <div class="dashboard-description-section-form">
    <div class="dashboard-description-section-form__form" fxLayout="column" fxLayoutAlign="center">
      <dashboard-image-upload
        formControlName="imageUrl"
        [label]="'Upload section image'"
        [isEdit]="isEdit"
        [isImageToEdit]="isImageToEdit"
        [imgPath]="imgPath"
        [keyForUpload]="keyForUpload"
        [idsForUpload]="idsForUpload"
        [size]="IMAGE_SIZES.MEDIUM"
      >
      </dashboard-image-upload>
      <div>
        <mat-tab-group
          mat-align-tabs="end"
          (selectedTabChange)="selectTemplateLanguage($event)"
          #languageTabs
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language?.name">
            <ng-container *ngTemplateOutlet="tabContent"></ng-container>
          </mat-tab>
        </mat-tab-group>
        <ng-template #tabContent>
          <div formArrayName="translations" *ngFor="let item of translations.controls; let i = index">
            <mat-form-field
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage?.code &&
                (item.get('identifier').value === SECTION_IMAGE_CAPTION_IDENTIFIER ||
                  item.get('identifier').value === CONTENT_TITLE_IDENTIFIER)
              "
              fxFlex="100"
            >
              <input
                matInput
                formControlName="translation"
                [placeholder]="
                  item.get('identifier').value === SECTION_IMAGE_CAPTION_IDENTIFIER ? 'Image Caption' : 'Content Title'
                "
              />
              <mat-error
                *ngIf="
                  item.get('identifier').value === SECTION_IMAGE_CAPTION_IDENTIFIER &&
                  item.get('translation').hasError('maxlength')
                "
              >
                Image Caption should have
                <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
              </mat-error>
              <mat-error
                *ngIf="
                  item.get('identifier').value === CONTENT_TITLE_IDENTIFIER &&
                  item.get('translation').hasError('maxlength')
                "
              >
                Content Title should have
                <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
              </mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <div *ngIf="isEditorInitialized">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          #languageTabsEditor
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
                <div
                  class="dashboard-description-section-form__form-text-editor"
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === CONTENT_TEXT_IDENTIFIER
                  "
                  fxFill
                >
                  <label class="dashboard-description-section-form__form-text-editor-label">Content Text</label>
                  <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                  <mat-error
                    class="dashboard-description-section-form__form__text-editor-error"
                    *ngIf="item.invalid && item.get('translation').hasError('maxlength')"
                  >
                    Content text should have
                    <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong>
                    characters
                  </mat-error>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div>
        <mat-tab-group
          mat-align-tabs="end"
          (selectedTabChange)="selectTemplateLanguage($event)"
          #languageTabs
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language?.name">
            <ng-template matTabContent>
              <div formArrayName="translations" *ngFor="let item of translations.controls; let i = index">
                <mat-form-field
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === SECTION_BUTTON_TEXT_IDENTIFIER
                  "
                  fxFill
                >
                  <input matInput formControlName="translation" [placeholder]="'Button text'" />
                  <mat-error
                    *ngIf="
                      item.get('identifier').value === SECTION_BUTTON_TEXT_IDENTIFIER &&
                      item.get('translation').hasError('maxlength')
                    "
                  >
                    Button text should have
                    <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
                  </mat-error>
                </mat-form-field>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
      <mat-radio-group formControlName="chosenOption" fxLayout="row" fxLayoutGap="30px">
        <mat-radio-button [value]="SECTION_BUTTON_OPTIONS.HYPERLINK">Hyperlink button</mat-radio-button>
        <mat-radio-button [value]="SECTION_BUTTON_OPTIONS.LINK_TO_SECTION">Section button</mat-radio-button>
      </mat-radio-group>
      <div class="dashboard-description-section-form__form-button-link">
        <mat-form-field
          *ngIf="chosenOption?.value && chosenOption?.value === SECTION_BUTTON_OPTIONS.HYPERLINK"
          fxFill
          appearance="fill"
        >
          <mat-label>Hyperlink</mat-label>
          <input matInput formControlName="hyperlink" />
        </mat-form-field>
        <mat-form-field
          *ngIf="chosenOption.value && chosenOption.value === SECTION_BUTTON_OPTIONS.LINK_TO_SECTION"
          fxFill
          appearance="fill"
        >
          <mat-label>Scroll to section</mat-label>
          <mat-select [value]="selectedSection?.linkToSection" [formControl]="linkToSection">
            <mat-option *ngFor="let section of availableSections" [value]="section.id">
              {{ section.sectionName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
